import api from './api';

export default {
  getAll() { return api.get('/tutorials'); },
  getById(id: number) { return api.get(`/tutorials/${id}`); },
  create(data: any) { return api.post('/tutorials', data); },
  update(id: number, data: any) { return api.put(`/tutorials/${id}`, data); },
  delete(id: number) { return api.delete(`/tutorials/${id}`); }
};
